<template>
  <div class="child-view">
    <div class="header">
      <div class="back">
        <div style="width: 90%; margin: auto; padding: 20px 0; display: flex">
          <img
            src="http://jmylapi.zhsq.cloud//upload/files/2022/11/fKuwy3jLIVZbf96a7050c0fdc653b642fb4372352ef9.png"
            style="width: 70px; height: 70px"
            />
          <span class="name">姓名</span>
        </div>
        <div style="width: 100%">
          <div style="width: 95%; margin: auto">
            <div class="boxStyle">
              <div class="title"
                >薪资收益 <span class="miaoshu">/元</span></div
              >
              <div class="boxTopCount">
                <div class="boxTopCount01">
                  <!-- <div> --> 
                  <img
                    src="https://jmylapi.zhsq.cloud//upload/files/2022/11/CO1swVQy0zTG6d90db0096b37d941f8904cbfc549944.png"
                    alt=""
                    class="img"
                  />
                  应发工资
                  <!-- </div> -->
                  <!-- <div> -->
                  <span class="money">1230.0</span>
                  <!-- </div> -->
                </div>
                <div class="boxTopCount01">
                  <img
                    src="https://jmylapi.zhsq.cloud//upload/files/2022/11/l1xLuhLWw6Ey346b55bbeb2f2fbe09758ac6864ea9e0.png"
                    alt=""
                    class="img"
                  />
                  实发工资 <span class="money">1230.0</span>
                </div>
              </div>
              <div class="boxTopCount" style="justify-content: left">
                <div class="boxTopCount01">
                  <img
                    src="https://jmylapi.zhsq.cloud//upload/files/2022/11/SLEilbYtlHluce535946d78513f3ee3c707db3de826b.png"
                    alt=""
                    class="img"
                  />
                  预期工资 <span class="money">1230.0</span>
                </div>
                <!-- <div>
                    <img src="../../imgs/应发.png" alt="" class="img" /> 实发工资 <span class="money">1230.0</span>
                </div> -->
              </div>
            </div>
            <div class="boxOldman">
              <div class="boxStyle" style="width: 45%">
                <div class="oldmanNum">
                  <div style="margin-bottom: 5px; font-size: 17px"
                    >老人总数</div
                  >
                  <div style="color: #5e95ed">780</div>
                </div>
                <div class="oldmanImg">
                  <img
                    src="https://jmylapi.zhsq.cloud//upload/files/2022/11/qyhv88b1f3k661b212ddf73f68818d44aa0420c5243f.png"
                    />
                </div>
              </div>
              <div class="boxStyle" style="width: 45%">
                <div class="oldmanNum">
                  <div style="margin-bottom: 5px; font-size: 17px"
                    >当前老人</div
                  >
                  <div style="color: #feaa0d">680</div>
                </div>
                <div class="oldmanImg">
                  <img
                    src="https://jmylapi.zhsq.cloud//upload/files/2022/11/WKY1l3r7rhhr5dfd27ebabf2053c19cae962c43a5b3e.png"
                    />
                </div>
              </div>
            </div>
            <div class="boxStyle" style="margin-top: 20px; padding: 10px">
              <div class="biankuang1"></div>
              <span style="font-size: 16px; margin-left: 10px">我的工单</span>
              <div style="width: 50%; margin: auto">
                <!-- <canvas
                  canvas-id="columnCanvas"
                  disable-scroll="false"
                  class="pieCanvas"
                  force-use-old-canvas="{{false}}"
                  style="width: 100%; height: 220px"
                ></canvas> -->
              </div>
            </div>
            <div class="boxStyle" style="margin-top: 20px; padding: 10px">
              <div class="biankuang1"></div>
              <span style="font-size: 16px; margin-left: 10px">满意度</span>
              <div style="display: flex; justify-content: space-between">
                <div style="width: 30%; margin: auto">
                    <div id="manyi02" style="width: 100%; height: 220px">

                    </div>
                  <!-- <canvas
                    canvas-id="manyi02"
                    disable-scroll="false"
                    class="pieCanvas"
                    force-use-old-canvas="{{false}}"
                    style="width: 100%; height: 220px"
                  ></canvas> -->
                </div>

                <div style="width: 39%; margin: auto">
                  <!-- <canvas
                    canvas-id="manyi01"
                    disable-scroll="false"
                    class="pieCanvas"
                    force-use-old-canvas="{{false}}"
                    style="width: 95%; height: 220px"
                  ></canvas> -->
                </div>
                <div style="width: 30%; margin: auto">
                  <!-- <canvas
                    canvas-id="manyi03"
                    disable-scroll="false"
                    class="pieCanvas"
                    force-use-old-canvas="{{false}}"
                    style="width: 100%; height: 220px"
                  ></canvas> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  data () {
    return {
    };
  },
  mounted(){
    this.manyi02()
  },
  methods: {
    manyi02(Title, row) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("manyi02"));
      var that = this;
      // 绘制图表
      myChart.setOption({
        title: { text: "老人分布" },
        color: ["#5bc0de"],
        tooltip: {},
        xAxis: {
          data: ['1','2','3','4','5','6','7','8'],
          axisLabel: {
            interval: 0,
          },
        },

        yAxis: {},
        series: [
          {
            name: "老人数量",
            type: "bar",
            barWidth: "40%",
            label: {
              show: true,
              position: "top",
            },
            // data: row,
            data: [
              { value: "1580", ID: "4103050601" },
              { value: "2424", ID: "4103050602" },
              { value: "1503", ID: "4103050603" },
              { value: "2560", ID: "4103050604" },
              { value: "1353", ID: "4103050605" },
              { value: "1418", ID: "4103050606" },
              { value: "269", ID: "4103050607" },
              { value: "299", ID: "4103050608" },
            ],
          },
        ],
        // dataZoom: [
        //   {
        //     type: "slider",
        //     show: true, //flase直接隐藏图形
        //     xAxisIndex: [0],
        //     left: "9%", //滚动条靠左侧的百分比
        //     bottom: -5,
        //     start: 0, //滚动条的起始位置
        //     end: 3, //滚动条的截止位置（按比例分割你的柱状图x轴长度）
        //   },
        // ],
      });
    },
  }
}
</script>
<style scoped>
.child-view {
    min-height: 100%;
  background-color: #f5f5f5;
}

.back {
  position: absolute;
  width: 100%;
  height: 170px;
  background-color: #6897ed;
}
.name{
  display: block;
    padding: 4px 0%;
    margin: 0 10%;
    span-align: center;
    font-size: 18px;
    line-height: 70px;
    color: white;
}
.boxStyle {
  /* border: 1px solid red; */
  background: white;
  padding: 5px;
  border-radius: 8px;
}

.title {
  font-size: 18px;
  font-weight: 550;
  margin: 10px;
}

.miaoshu {
  font-weight: 550;
  font-size: 14px;
  /* color:#ababab; */
}

.boxTopCount {
  display: flex;
  justify-content: space-between;
  margin: 20px;
}

.img {
  width: 16px;
  height: 16px;
  margin: 7px 0;
}

.money {
  color: #FEAA0D;
}

.boxTopCount01 {
  width: 45%;
  display: flex;
  justify-content: space-between;
  line-height: 30px;
}

.boxOldman {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.oldmanNum {
  float: left;
  margin: 5px 10px;
}

.oldmanImg {
  float: right;
  margin-top: 20px;
  margin-right: 10px;
}

.oldmanImg img {
  width: 40px;
  height: 40px;
}

.biankuang1 {
  border: 2px solid #6182FA;
  width: 0;
  height: 17px;
  float: left;
  border-radius: 2px;
  background: #6182FA;
}
</style>